/* popup-links-strict: popup any [data-p-popup-links]
 *
 * Data attrib data-p-popup-links-window will be used as name for the
 * popped-up window
 *
 * Data attrib data-p-popup-links-props will be used as the
 * window.open() property argument.
 *
 * Author: Niels Giesen
 * Copyright 2017Berkeley Bridge
 *
 */
(function ($) {
  var _popup;

  /**
   * Event handler.
   *
   * Open link in other, special window, regardless of
   * whether it has <tt>target="_blank"</tt> set.
   *
   * @param {Event} ev The event invoking the function.
   */
  function openExternalLink(ev) {
    var popup,
      name = unescape(this.getAttribute("data-p-popup-links-window")),
      props = unescape(this.getAttribute("data-p-popup-links-props"));

    popup = window.open(
      this.href,
      name ? (name === "null" ? null : name) : "popup",
      props
    );
    if (!name) {
      _popup = popup;
    }
    window.child = _popup;

    ev.preventDefault();
    ev.stopImmediatePropagation();
    return false;
  }

  /**
   * Attach openExternalLink Event to <tt>[data-p-popup-links]</tt> links.
   */
  $(document).on("click", "[data-p-popup-links]", openExternalLink);

  /**
   * Close the _popup window when closing main
   */
  $(window).on("beforeunload", function (ev) {
    _popup && !_popup.closed && _popup.close();
  });
})(jQuery);
